<template><component v-if="periodComponentName" :is="periodComponentName" /></template>

<script>
import { getCourseViewer } from 'views/Course/utils/viewer';

/**
 * @module CoursePeriodEntry
 * @desc CoursePeriod 独立页分发壳。`/course/period/:id/:period` 不承载 Course 介绍。
 */
export default {
  name: 'CoursePeriodEntry',
  components: {
    StudentPeriod: () => import('./Student'),
    TeacherPeriod: () => import('./Teacher'),
    AdminPeriod: () => import('./Admin')
  },
  data: () => ({
    viewer: ''
  }),
  computed: {
    periodComponentName() {
      if (this.viewer === 'student') return 'StudentPeriod';
      if (this.viewer === 'teacher') return 'TeacherPeriod';
      if (this.viewer === 'admin') return 'AdminPeriod';
      return '';
    }
  },
  async created() {
    this.viewer = await getCourseViewer(this);
    if (this.periodComponentName) return;
    this.$router.replace({ name: this.viewer === 'teacher' || this.viewer === 'admin' ? 'course-workspace' : 'course-list' });
  }
};
</script>
